import { createSlice } from "@reduxjs/toolkit"
import type { PayloadAction } from "@reduxjs/toolkit"
import { App } from "@app/interfaces"
import { RootState, StateFromRoot, registerReducer, store } from "@/core/store"

const STATE_KEY = "auth"
const STORAGE_KEY = STATE_KEY
export type AuthState = App.AuthState

const defaultState: AuthState = {
  type: App.AuthType.STANDARD,
  role: App.UserRole.ANON,
}
const persistantState = localStorage.getItem(STORAGE_KEY)

const initialState: AuthState = persistantState
  ? JSON.parse(persistantState)
  : defaultState

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAuth: (state, { payload }: PayloadAction<AuthState>) => {
      return { ...payload }
    },
    setStandardAuth: (
      state,
      {
        payload: { token, role },
      }: PayloadAction<{ token: string; role: App.UserRole }>,
    ) => {
      return {
        type: App.AuthType.STANDARD,
        token,
        role,
      }
    },
    resetAuth: () => {
      localStorage.removeItem(STORAGE_KEY)
      return defaultState
    },
  },
})
registerReducer(authSlice.name, authSlice.reducer)
store.subscribe(() => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(store.getState().auth))
})

export const { setAuth, setStandardAuth, resetAuth } = authSlice.actions

export const getAuth = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth
export const getAuthToken = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.token
export const getAuthRole = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.role
export const getAuthType = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.type
export const getAuthUserInfo = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.userInfo
export const getRefreshToken = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.refreshToken
export const getIdToken = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.idToken
export const isOIDCAuth = (state: RootState<StateFromRoot<AuthState>>) =>
  state.auth.type === App.AuthType.OIDC
